import axios from "axios";

export default axios.create({
  baseURL: "https://smartcampus.my.id",
  headers: {
    "Content-type": "application/json"
  }
});